<template>
	<div class="view-wrapper about" v-if="document">
		<div class="container">
			<h1>{{ document.title }}</h1>
			<div>
				<c-flex-content :content="document.flex_content" />
			</div>
		</div>
		<c-team :team="document.team_members"></c-team>
		<c-clients filter="all"></c-clients>
		<section class="about__list" v-if="document.press_release_repeater.length">
			<div class="container">
				<h2>{{ document.press_release_title }}</h2>
				<ul>
					<li class="about__list__item" v-for="item in document.press_release_repeater">
						<span class="about__list__meta">{{ item.title }}</span>
						<h3 class="about__list__headline"><div v-html="item.content" /></h3>
					</li>
				</ul>
			</div>
		</section>
		<section class="about__list" v-if="document.jobs_active">
			<div class="container">
				<h2>{{ document.jobs_title }}</h2>
				<ul>
					<li class="about__list__item" v-for="item in document.jobs_repeater">
						<span class="about__list__meta">{{ item.title }}</span>
						<h3 class="about__list__headline"><div v-html="item.content" /></h3>
					</li>
				</ul>
			</div>
		</section>
	</div>
</template>

<script>
import * as utils from '@/utils/utils'
import defaultHeadData from '@/utils/defaultHeadData'
import getAboutData from '@/api/about.wp.api'
import CTeam from '@/components/Team'
import CClients from '@/components/Clients'
import CFlexContent from '@/components/FlexContent'

export default {
	name: 'about',
	components: {
		CTeam,
		CClients,
		CFlexContent
	},
	data: () => ({
		documentData: {},
		team: {},
		headData: defaultHeadData
	}),
	computed: {
		settings() {
			return this.$store.state.general.settings
		},
		defaultMeta() {
			return this.$store.state.general.siteSettings[this.settings.currentLang].defaultMeta
		},
		siteSettings() {
			return this.$store.state.general.siteSettings
		},
		activeRouteUrl() {
			return utils.constructActiveRouteUrl(this.$route.fullPath)
		},
		document() {
			return this.documentData
		}
	},
	watch: {
		'$route': function() {
			this.setHomeData()
			this.updateHeadData()
		},
		defaultMeta: function() {
			this.updateHeadData()
		}
	},
	head: {
		title: function() {
			return utils.transformHeadTitle(this.headData.title)
		},
		meta: function() {
			return utils.transformHeadMeta(this.headData.meta)
		},
		link: function() {
			return utils.transformHeadLink({ data: this.headData.link, i18n: true })
		}
	},
	beforeMount() {
		this.setHomeData()
		this.$store.dispatch('setAltLanguageLink', { lang: 'de-ch', link: '/about' })
		this.$store.dispatch('setAltLanguageLink', { lang: 'en-us', link: '/en/about' })

	},
	methods: {
		setHomeData() {
			this.documentData = null
			getAboutData({ lang: this.settings.currentLang }).then(payload => {
				this.documentData = payload
				utils.setHtmlLang(this.settings.currentLang)
				this.updateHeadData()
			})
		},
		updateHeadData() {
			if (this.siteSettings[this.settings.currentLang].defaultMeta && this.documentData) {
				this.headData = utils.transformHeadData({
					meta: this.documentData.meta,
					defaultMeta: this.siteSettings[this.settings.currentLang].defaultMeta,
					settings: this.settings,
					activeRouteUrl: this.activeRouteUrl
				})
				this.$emit('updateHead')
			}
		}
	}
}
</script>

<style lang="scss">

	@import "../assets/css/helpers";

	.about {
		padding-top: 3rem;
		padding-bottom: 4rem;

		p {
			max-width: 45rem;
		}

		&__list {
			margin: 3rem 0;

			@include mq($from: medium) {
				margin-top: 5rem;
			}

			h2 {
				margin-bottom: 2rem;
				color: $colorBrandMain;
				font-weight: 600;
			}
			&__meta {
				font-size: .9rem;
				color: $colorGray;
			}
			&__headline {
				font-size: 1.4rem;
				font-weight: 600;

				a {
					text-decoration: none;
					font-family: $fontFamilyBase;
					line-height: 1;
				}
				p {
					line-height: 1.3;
					max-width: 30rem;
				}
			}
			&__item {
				display: block;
				margin-bottom: 1.5rem;
			}
			&__content {
				font-family: $fontFamilyBase;
				font-size: .8rem;
				margin-top: .5rem;
			}
		}
		&__jobs {
			padding-bottom: 6rem;

			&__item {
				margin-bottom: 1.5rem;
			}
			&__headline {
				font-size: 1.4rem;
				font-weight: 600;
				margin-bottom: .25rem;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// About.vue?7e70bee6